import { createRoute } from '@tanstack/react-router'

import { lazyPage } from '@/lib/lazy-page'

import { learningRoute } from './learning-route'

export const myLearningRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'my-learning',
  component: lazyPage(() => import('./features/my-learning/my-learning-page.lazy'), 'MyLearningPage'),
})

export const coursesRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'courses',
  component: lazyPage(() => import('./features/courses/courses-page.lazy'), 'CoursesPage'),
})

export const courseDetailRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'courses/$courseId',
  component: lazyPage(() => import('./features/course-detail/course-detail-page.lazy'), 'CourseDetailRoutePage'),
})

export const modulePlayerRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'courses/$courseId/modules/$moduleId',
  component: lazyPage(() => import('./features/module-player/module-player-page.lazy'), 'ModulePlayerRoutePage'),
})

export const learningUsersRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'users',
  component: lazyPage(() => import('./features/users/learning-users-page.lazy'), 'LearningUsersPage'),
})

export const learningTeamsRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'teams',
  component: lazyPage(() => import('./features/teams/learning-teams-page.lazy'), 'LearningTeamsPage'),
})

export const learningCourseAdminRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'admin/courses',
  component: lazyPage(() => import('./features/course-admin/learning-course-admin-page.lazy'), 'LearningCourseAdminPage'),
})

export const learningCourseAdminDetailRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'admin/courses/$courseId',
  component: lazyPage(() => import('./features/course-admin/course-admin-detail-page.lazy'), 'CourseAdminDetailRoutePage'),
})

export const learningTeamDetailRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'teams/$teamId',
  component: lazyPage(() => import('./features/teams/team-detail-page.lazy'), 'TeamDetailRoutePage'),
})

export const learningModulePreviewRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'admin/courses/$courseId/modules/$moduleId/preview',
  component: lazyPage(() => import('./features/course-admin/module-preview-page.lazy'), 'ModulePreviewRoutePage'),
})

export const trainingModulesRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'training-modules',
  component: lazyPage(() => import('./features/sections/learning-sections.lazy'), 'TrainingModulesPage'),
})

export const contentLibraryRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'content-library',
  component: lazyPage(() => import('./features/sections/learning-sections.lazy'), 'ContentLibraryPage'),
})

export const leaderboardRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'leaderboard',
  component: lazyPage(() => import('./features/sections/learning-sections.lazy'), 'LeaderboardPage'),
})

export const myRecordRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'my-record',
  component: lazyPage(() => import('./features/my-record/my-record-page.lazy'), 'MyRecordPage'),
})

export const courseCertificateRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'my-record/courses/$courseId/certificate',
  component: lazyPage(() => import('./features/my-record/certificate-page.lazy'), 'CourseCertificateRoutePage'),
})

export const moduleCertificateRoute = createRoute({
  getParentRoute: () => learningRoute,
  path: 'my-record/courses/$courseId/modules/$moduleId/certificate',
  component: lazyPage(() => import('./features/my-record/certificate-page.lazy'), 'ModuleCertificateRoutePage'),
})
